import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

import { Data } from '../../models/data';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../../services/api/api.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  data = new Data();
  companyg:any;
  name: any;
  address: any;
  phone: any;
  email: any;
  current_year: number = new Date().getFullYear();

  credential = {npassword: null, vpassword: null, user: null};

  constructor(private apiService: ApiService, private authService: AuthService, public dialog: MatDialog, private spinner: NgxSpinnerService) { 
    this.credential.npassword = "";
    this.credential.vpassword = "";
    this.credential.user = localStorage.getItem('user');
  }


  ngOnInit() {
    this.companyg = localStorage.getItem('companyg');
    this.name = localStorage.getItem('firstname') + ' ' + localStorage.getItem('lastname');
    this.address = localStorage.getItem('address');
    this.phone = localStorage.getItem('phone');
    this.email = localStorage.getItem('email');

  }

  change () {
    this.data =  {
      id: 2,
      name: 'changePasswordNew',
      content: {
        id : this.credential.user,
        mac: this.credential.npassword
      }
    };

    this.spinner.show();
    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);
      this.spinner.hide();
      this.openDialog();

    });

  }

  logout() {
    this.authService.logout();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogProfilePage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}


@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogProfilePage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}